var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4706_11483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4668 7.11509L13.3614 6.38884M7.42243 2.39501L1.53345 7.11509V12.0793",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53345 15.5282V7.11572L5.24842 11.0591H10.4943L14.4668 7.11572V15.5282H1.53345Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25713 9.48521C7.84765 9.495 7.43122 9.38291 7.06504 9.13765C6.12116 8.50545 5.86849 7.22778 6.50069 6.2839C7.13289 5.34003 8.41056 5.08736 9.35443 5.71956C10.2983 6.35176 10.551 7.62942 9.91878 8.5733C9.74347 8.83503 9.51854 9.04361 9.26485 9.19492",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2744 6.66874C7.35533 6.55586 7.45123 6.46184 7.56208 6.38669C7.63493 6.33791 7.71455 6.30478 7.80094 6.2873C7.87656 6.272 7.94237 6.33211 7.94967 6.40893V6.40893C7.95818 6.49839 7.88363 6.57353 7.79766 6.59972C7.76593 6.60939 7.73441 6.62227 7.70311 6.63837C7.61588 6.68434 7.54286 6.74457 7.48404 6.81905L8.1667 7.30851C8.23472 7.25148 8.30619 7.20099 8.38111 7.15704C8.45782 7.11438 8.53566 7.08338 8.61464 7.06404C8.69232 7.04649 8.77101 7.04458 8.85069 7.05831C8.93217 7.07332 9.01322 7.10973 9.09385 7.16754C9.16911 7.2215 9.22781 7.28529 9.26997 7.35893C9.31213 7.43256 9.33826 7.50962 9.34837 7.59012C9.35898 7.67369 9.35461 7.75736 9.33523 7.84114C9.31765 7.9262 9.2865 8.00559 9.24177 8.07933L9.35465 8.16026C9.39028 8.1858 9.39845 8.23539 9.37291 8.27101V8.27101C9.34737 8.30664 9.29778 8.31481 9.26216 8.28927L9.14927 8.20833C9.0799 8.30509 8.9939 8.38721 8.89126 8.45469C8.83071 8.49504 8.7677 8.52535 8.70224 8.5456C8.62372 8.56989 8.55019 8.50879 8.54069 8.42715V8.42715V8.42715C8.53152 8.3483 8.59302 8.2803 8.66857 8.25594C8.69839 8.24633 8.72727 8.23394 8.7552 8.21878C8.82805 8.18149 8.88953 8.1279 8.93964 8.05802L8.27041 7.57819C8.19573 7.63316 8.12054 7.68506 8.04484 7.73388C7.96915 7.78269 7.89207 7.81831 7.8136 7.84072C7.73564 7.86621 7.65618 7.87299 7.57521 7.86106C7.49296 7.85091 7.40793 7.81437 7.32013 7.75142C7.2395 7.69361 7.17786 7.62635 7.13519 7.54964C7.09253 7.47293 7.06653 7.39189 7.0572 7.30653C7.04658 7.22296 7.05225 7.13749 7.07419 7.05013C7.09613 6.96278 7.13203 6.87865 7.1819 6.79775L7.05558 6.70718C7.01995 6.68163 7.01178 6.63205 7.03732 6.59642V6.59642C7.06287 6.5608 7.11245 6.55263 7.14808 6.57817L7.2744 6.66874ZM9.03213 7.92902C9.07896 7.82966 9.09297 7.73255 9.07417 7.63768C9.05589 7.5459 9.00374 7.46917 8.91773 7.4075C8.87115 7.3741 8.82659 7.35301 8.78406 7.34422C8.74024 7.33722 8.6977 7.33791 8.65642 7.3463C8.61386 7.35647 8.57141 7.37216 8.52908 7.39335C8.48726 7.41763 8.44352 7.44459 8.39784 7.47424L9.03213 7.92902ZM7.39154 6.94806C7.33677 7.04714 7.31711 7.14835 7.33256 7.25166C7.34672 7.35677 7.39681 7.44015 7.48281 7.50182C7.53119 7.53651 7.57972 7.55774 7.62841 7.56551C7.67709 7.57329 7.72489 7.57094 7.77182 7.55846C7.81874 7.54599 7.8644 7.52582 7.90879 7.49797C7.95368 7.47319 7.99718 7.44469 8.03927 7.41247L7.39154 6.94806Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5081 5.48612L9.651 10.7931L10.2577 11.234L14.8393 4.93021C15.1093 4.55873 15.0272 4.03875 14.656 3.76841L9.66086 0.130704C9.29046 -0.139039 8.77168 -0.0585509 8.50043 0.310747L2.61401 8.3248L3.21848 8.76879L8.38563 1.73397L10.2465 1.48497L13.1694 3.61362L13.5081 5.48612Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.2415,
    cy: 4.83008,
    r: 0.571274,
    transform: "rotate(126.064 10.2415 4.83008)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.16455,
    cy: 10.0371,
    r: 0.571274,
    transform: "rotate(126.064 6.16455 10.0371)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5812 11.0962L14.3298 15.4211",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31679 11.0962L1.56812 15.4211",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4706_11483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0.16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxOutline);
export default __webpack_public_path__ + "static/media/tax-outline.47ca1bbe94c4a45bc0a8910440e95ea3.svg";
export { ForwardRef as ReactComponent };